module.exports = __webpack_public_path__ + "static/media/mv.6073d2de.svg";